import React, { useEffect, useState } from 'react'
import { FormCustom, Input, SwitchToggle } from '../../../components/form'
import ReactPlaceholder from 'react-placeholder/lib'
import { useGetId, useSaveUpdate } from '../../../hooks/process-data'
import { useMemo } from 'react'

const TypeEventForm = ({ rowId, setReload }) => {
  const [row, setRow] = useState({
    p_id_type_event: '',
    p_name_type_event: '',
    p_enabled_type_event: 0,
  })
  const [ready, setReady] = useState(false);

  const dataSubmit = useMemo(() => {
    return row;
  }, [row])

  const { doSubmit, setDoSubmit } = useSaveUpdate({
    data: dataSubmit,
    url: '/type-event',
    hasFile: true,
    setReload
  })

  const { isProcessing, getRow, error } = useGetId({
    url: '/type-event/' + rowId,
    rowId: rowId
  })

  useEffect(() => {
    const getData = async function () {
      if (error) {
        setReload();
      } else {
        if (!isProcessing && !ready) {
          if (rowId) {
            setRow({
              p_id_type_event: getRow.id_type_event,
              p_name_type_event: getRow.name_type_event,
              p_enabled_type_event: getRow.enabled_type_event,
            })
          }
          setReady(true);
        }
      }
    }

    getData();
  }, [isProcessing, getRow, error, setReload, rowId, ready])

  return <ReactPlaceholder ready={ready} rows={5}>
    <FormCustom onSubmit={() => {
      setDoSubmit(true)
    }} loadSubmit={doSubmit}>
      <Input
        text="Nombre"
        placeholder="Nombre"
        classNameParent="col-12 mb-3"
        required
        invalid="El campo es obligatorio."
        value={row.p_name_type_event}
        onChange={e => setRow({ ...row, p_name_type_event: e.target.value })}
        maxLength={255}
      />
      <SwitchToggle
        id="type_event-enabled"
        textCheck="Desactivar"
        textUnChecked="Activar"
        classNameParent="col-12 mb-3"
        checked={row.p_enabled_type_event === 1}
        onChange={e => setRow({ ...row, p_enabled_type_event: e.target.checked ? 1 : 0 })}
      />
    </FormCustom>
  </ReactPlaceholder>
}

TypeEventForm.defaultProps = {
  rowId: '',
  setReload: () => { },
}

export {
  TypeEventForm
};